module.exports = __webpack_public_path__ + "src/img/notice.24e9c3e3.svg";